'use client'

import ViverseButton from '@/components/ViverseButton'
import { useTranslations } from 'next-intl'
import Link from 'next/link'

export default function AccessDenied() {
  const t = useTranslations()

  return (
    <div className="flex h-svh w-full flex-col items-center justify-center gap-y-5 bg-[radial-gradient(50%_50%_at_50%_50%,_#15171b_0%,_#282c31_100%)]">
      <p className="px-2 text-center text-base">{t('exited-room-screen.reason.denied')}</p>

      <Link href="/" className="text-base font-medium text-white">
        <ViverseButton>{t('exited-room-screen.home-button')}</ViverseButton>
      </Link>
    </div>
  )
}
